import { MODAL_CONTENT_TYPES } from '../modal/constants';
import { t } from '../../utils/translation';

export const getOpenPreviewPromptModalConfig = () => ({
  closeOnOverlayClick: true,
  title: t('widget.preview-prompt.preview-mode'),
  contentType: MODAL_CONTENT_TYPES.PREVIEW_PROMPT,
});
